import { ref } from 'vue';
import {
  countryCodeIsBrazil,
  peekCachedCurrentIpCountryCode,
  resolveCountryCodeFromCurrentIp,
} from '@/utils/ip-country-lookup';

/**
 * 落地 PIX 扫码仅当前出口 IP 为 BR 时展示。
 * 资料国家码不参与；探测失败 fail-closed（不展示）。
 */
export const BRAZIL_PAY_IP_GUARD_ENABLED = true;

export const brazilPayIpAllowed = ref(
  !BRAZIL_PAY_IP_GUARD_ENABLED || countryCodeIsBrazil(peekCachedCurrentIpCountryCode())
);

export function resetBrazilPayIpAllowed() {
  brazilPayIpAllowed.value = !BRAZIL_PAY_IP_GUARD_ENABLED;
}

/**
 * 仅看当前出口网络。打开弹窗时跟在美国 IP 探测之后调用即可复用缓存。
 * @param {{ forceRefresh?: boolean }} [options]
 * @returns {Promise<boolean>}
 */
export async function resolveIsBrazilPayIpAllowed({ forceRefresh = false } = {}) {
  if (!BRAZIL_PAY_IP_GUARD_ENABLED) {
    brazilPayIpAllowed.value = true;
    return true;
  }
  const countryCode = await resolveCountryCodeFromCurrentIp({ forceRefresh }).catch(() => null);
  const allowed = countryCodeIsBrazil(countryCode);
  brazilPayIpAllowed.value = allowed;
  return allowed;
}
